var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "border border-light py-1 px-1 mb-2 alert-fix",
      attrs: { id: "pif-infos" },
    },
    [
      _c("h4", { staticClass: "h4 h4-fix mb-0" }, [
        _vm._v("\n        " + _vm._s(_vm.pifInfos.title) + "\n    "),
      ]),
      _vm._v(" "),
      _vm.pifInfos.radInfos
        ? _c("div", { staticClass: "alert-container alert-info" }, [
            _c("p", { staticClass: "alert", attrs: { role: "alert" } }, [
              _c("span", {
                staticClass: "alert-icon",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "ob1-alert-title" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.pifInfos.radInfos.content) +
                    "\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "alert-content" }, [
              _c(
                "a",
                {
                  staticClass: "o-link-arrow ob1-link-dark ob1-link-large",
                  attrs: {
                    href: _vm.pifInfos.url,
                    "data-oevent-category":
                      _vm.pifInfos.radInfos.buttonTms.category,
                    "data-oevent-action":
                      _vm.pifInfos.radInfos.buttonTms.action,
                    "data-oevent-label": _vm.pifInfos.radInfos.buttonTms.label,
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.pifInfos.radInfos.buttonLabel) +
                      "\n            "
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ol",
        {
          staticClass: "ob1-timeline pif-infos--collapse",
          attrs: { hidden: !_vm.showDetails },
        },
        _vm._l(_vm.pifInfos.deploymentSteps, function (step) {
          return _c(
            "li",
            {
              staticClass: "ob1-timeline-step",
              class:
                (step.current ? "active progress-66" : "") +
                (step.complete ? "complete" : ""),
            },
            [
              _c("p", { staticClass: "ob1-timeline-title" }, [
                _vm._v(
                  "\n                " + _vm._s(step.title) + "\n            "
                ),
              ]),
              _vm._v(" "),
              step.syndicInfos
                ? _c("p", { staticClass: "ob1-timeline-description" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(step.syndicInfos.description) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              step.syndicInfos
                ? _c("p", { staticClass: "ob1-timeline-description" }, [
                    _c(
                      "a",
                      {
                        staticClass: "o-link-arrow",
                        attrs: {
                          href: step.syndicInfos.courrierTypeLink,
                          target: "_blank",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(step.syndicInfos.courrierTypeLabel) +
                            "\n                "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "ol",
        {
          staticClass:
            "ob1-timeline ob1-timeline--collapsed pif-infos--collapse",
          attrs: { hidden: _vm.showDetails },
        },
        _vm._l(_vm.pifInfos.deploymentSteps, function (step) {
          return step.current || step.complete
            ? _c(
                "li",
                {
                  staticClass: "ob1-timeline-step",
                  class: step.current ? "active" : "complete",
                },
                [
                  _c("p", { staticClass: "ob1-timeline-title" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(step.title) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  step.syndicInfos
                    ? _c("p", { staticClass: "ob1-timeline-description" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(step.syndicInfos.description) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  step.syndicInfos
                    ? _c("p", { staticClass: "ob1-timeline-description" }, [
                        _c(
                          "a",
                          {
                            staticClass: "o-link-arrow",
                            attrs: {
                              href: step.syndicInfos.courrierTypeLink,
                              target: "_blank",
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(step.syndicInfos.courrierTypeLabel) +
                                "\n                "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e()
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn btn-secondary my-1 pif-infos--collapse",
          attrs: {
            href: _vm.pifInfos.url,
            hidden: !_vm.showDetails,
            "data-oevent-category": _vm.pifInfos.buttonTms.category,
            "data-oevent-action": _vm.pifInfos.buttonTms.action,
            "data-oevent-label": _vm.pifInfos.buttonTms.label,
          },
        },
        [_vm._v("\n        " + _vm._s(_vm.pifInfos.buttonLabel) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "o-link-arrow up pif-infos--collapse",
          attrs: { id: "pif-infos__collapse-button", hidden: !_vm.showDetails },
          on: { click: _vm.toggle },
        },
        [_vm._v("\n        " + _vm._s(_vm.pifInfos.seeLessLabel) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "o-link-arrow down pif-infos--collapse",
          attrs: { id: "pif-infos__expand-button", hidden: _vm.showDetails },
          on: { click: _vm.toggle },
        },
        [_vm._v("\n        " + _vm._s(_vm.pifInfos.seeMoreLabel) + "\n    ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }